import React from "react";
import {
  Box,
  Card,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ClockAlert, Asterisk, Trophy } from "lucide-react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TalentTestMiniDashboard = () => {
  const { TestType } = useParams();
  const navigate = useNavigate();

  // ✅ IMPORTANT: Decode URL param
  const decodedTestType = TestType ? decodeURIComponent(TestType) : "";

  // ✅ Encode helper for navigation
  const encode = (value) => encodeURIComponent(value);

  const data = [
    {
      id: "01",
      title: `${decodedTestType} Questions`,
      description: "View and manage all quiz questions easily.",
      icon: <ClockAlert size={32} />,
      gradient: "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)",
      route: `/FinalSelectedQuestions/${encode(decodedTestType)}`,
    },
    {
      id: "02",
      title: `${decodedTestType} Class Wise Students Result`,
      description:
        "Check Class Wise Students Performance and Detailed Information",
      icon: <Asterisk size={32} />,
      gradient: "linear-gradient(135deg, #06beb6 0%, #48b1bf 100%)",
      route: `/StudentsTestResults/${encode(decodedTestType)}`,
    },
    {
      id: "03",
      title: `${decodedTestType} Top 10 Students Performance`,
      description: "Check Top Students performance",
      icon: <Trophy size={32} />,
      gradient: "linear-gradient(135deg, #be069f 0%, #bd5ec0 100%)",
      route: `/TopPerformersResults/${encode(decodedTestType)}`,
    },
  ];

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <Box
      sx={{
        margin: "5.3% 1% 1%",
        background: "linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
      }}
    >
      {/* Header */}
      <Typography
        variant="h4"
        sx={{
          textAlign: "left",
          fontWeight: "bold",
          color: "#2e2a54",
          padding: "12px 0px 0px 15px",
          textShadow: "1px 1px 3px rgba(0,0,0,0.15)",
        }}
      >
        {decodedTestType} Talent Test
      </Typography>

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 5,
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{ width: "85%" }}
        >
          {data.map((item) => (
            <Grid item xs={12} sm={6} md={5} key={item.id}>
              <Card
                onClick={() => handleNavigation(item.route)}
                sx={{
                  height: 200,
                  borderRadius: "20px",
                  background: item.gradient,
                  color: "#fff",
                  boxShadow:
                    "0 10px 20px rgba(0,0,0,0.25), 0 6px 6px rgba(0,0,0,0.22)",
                  p: 2,
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  "&:hover": {
                    transform: "translateY(-8px) scale(1.03)",
                    boxShadow:
                      "0 20px 40px rgba(0,0,0,0.3), 0 8px 8px rgba(0,0,0,0.2)",
                  },
                }}
              >
                {/* Top Section */}
                <Box display="flex" alignItems="center" gap={2}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: "rgba(255,255,255,0.25)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backdropFilter: "blur(10px)",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      letterSpacing: 0.5,
                      color: "#fff",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>

                {/* Description */}
                <Typography
                  variant="body2"
                  sx={{
                    mt: 2,
                    opacity: 0.9,
                    fontSize: "15px",
                  }}
                >
                  {item.description}
                </Typography>

                {/* Button */}
                <Button
                  variant="contained"
                  sx={{
                    alignSelf: "flex-end",
                    mt: 3,
                    backgroundColor: "rgba(255,255,255,0.3)",
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "20px",
                    px: 3,
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.5)",
                    },
                  }}
                >
                  Go →
                </Button>
              </Card>
            </Grid>
          ))}
        </Grid>

        <ToastContainer position="top-right" autoClose={2000} />
      </Box>
    </Box>
  );
};

export default TalentTestMiniDashboard;